/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PropertyDTO
 */
export interface PropertyDTO {
    /**
     * 
     * @type {string}
     * @memberof PropertyDTO
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyDTO
     */
    value: string;
}

/**
 * Check if a given object implements the PropertyDTO interface.
 */
export function instanceOfPropertyDTO(value: object): value is PropertyDTO {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function PropertyDTOFromJSON(json: any): PropertyDTO {
    return PropertyDTOFromJSONTyped(json, false);
}

export function PropertyDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): PropertyDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'value': json['value'],
    };
}

export function PropertyDTOToJSON(value?: PropertyDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'key': value['key'],
        'value': value['value'],
    };
}

